/* global */
/**
 * Gender validation
 *
 * @author Andy Lemaire
 */

import $ from 'jquery';
import createLogger from 'components/logger/Logger';
import EventTypes from 'components/EventTypes';
import Singleton from 'components/utils/Singleton';

const Logger = createLogger('genderValidation');

class GenderValidation {
  constructor(form, selector) {
    Logger.info('Initialized');
    this.form = form;
    this.selector = selector;
    this.inputs = Array.from(this.form.querySelectorAll(selector));
    this.bindEvents();
  }

  bindEvents() {
    const onChangeHandler = event => this.validate(event.currentTarget);

    this.form.jq.on(EventTypes.FORM_VALIDATED, event => {
      const element = document.querySelector(this.selector);
      element && this.validate(element);
    });

    if (this.inputs) {
      this.inputs.forEach(input => input.addEventListener('change', onChangeHandler));
    }
  }

  validate(input) {
    const isChecked = this.inputs.some(input => input.checked);
    const isRequired = this.inputs.some(input => input.required);

    if (isRequired && !isChecked) {
      document.jq.trigger(EventTypes.FORM_ELEMENT_ERROR_SHOW, [
        this.form,
        input,
        window.labels.genderValidation.required,
      ]);
    } else {
      document.jq.trigger(EventTypes.FORM_ELEMENT_ERROR_HIDE, [this.form, input]);
    }
  }
}

export default Singleton.create(GenderValidation, 'GenderValidation');
